import { render, staticRenderFns } from "./ModalApproveCert.vue?vue&type=template&id=4c00a908&"
import script from "./ModalApproveCert.vue?vue&type=script&lang=js&"
export * from "./ModalApproveCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports